// extracted by mini-css-extract-plugin
module.exports = {"EditButton":"style_EditButton__10vDA","text":"style_text__3eKF8"};